<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    custom-height="h-auto"
    custom-width="lg:!w-[550px]"
  >
    <template #modal-header>
      <div class="flex flex-col">
        <div class="flex gap-2 items-center">
          <Icon name="Pencil" class="h-4 w-4 text-info" />
          <p class="font-inter text-sm text-info font-semibold">{{ props.subheader }}</p>
        </div>
        <h3 class="font-semibold text-[28px] text-strongest">{{ props.title }}</h3>
      </div>
    </template>
    <template #modal-body>
      <div class="p-6">
        <DetailBanner variant="secondary">
          <template #body>
            <AsteriskNotice :text="props.disclaimer_header" />
            <p class="font-inter font-medium text-strongest">
              {{ props.disclaimer }}
            </p>
          </template>
        </DetailBanner>
      </div>
    </template>
    <template #modal-footer>
      <div class="flex items-center justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary">
          <template #label> Cancel </template>
        </Button>
        <Button variant="primary-grey" @click="handleConfirm">
          <template #label> {{ props.cta_text }} </template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { Modal, Icon, Button, DetailBanner, AsteriskNotice } from "@/components";

const emit = defineEmits(["close-modal", "confirm"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  disclaimer: { type: String, required: true },
  disclaimer_header: { type: String, required: false, default: "Important Disclaimer" },
  title: { type: String, required: true },
  subheader: { type: String, required: true },
  cta_text: { type: String, required: true },
});

function handleConfirm() {
  emit("confirm");
  emit("close-modal");
}
</script>
